export default {"src":"/_next/static/media/Solution7.00749a4f.svg","height":49,"width":49};